import { i18n_t as $t } from '@/utils/i18n';

export function getI18nKeyForMetadataDisplayName (group, key, kind) {
    if (group === 'auto') {
        const autoMetadataTranslations = {
            id: kind === 'visitor' ? $t('common.Visitor ID') : $t('common.Account ID'),
            accountid: $t('common.Account ID'),
            accountids: $t('common.Account IDs'),
            createdat: $t('common.Created At'),
            firstvisit: $t('common.First Visit'),
            firstanonymousvisit: $t('common.First Mapped Anonymous Visit'),
            firstidentifiedvisit: $t('common.First Identified Visit'),
            lastvisit: $t('common.Last Visit'),
            lastbrowsername: $t('common.Most recent browser name'),
            lastbrowserversion: $t('common.Most recent browser version'),
            lastoperatingsystem: $t('common.Most recent operating system'),
            lastservername: $t('common.Most recent server name'),
            identifiedvisitorat: $t('common.Visitor identified at'),
            identifiedvisitorid: $t('common.Identified visitor ID'),
        };

        return autoMetadataTranslations[key];
    }
}

export function i18nizeMetadata (metadataSet, kind = 'visitor', group = 'auto') {
    if (Array.isArray(metadataSet)) {
        metadataSet = metadataSet.reduce((acc, item) => {
            acc[item.field] = item;

            return acc;
        }, {});
    }

    const transformedMetadata = { ...metadataSet };
    Object.entries(transformedMetadata).forEach(([key, value]) => {
        if (value) {
            transformedMetadata[key] = {
                ...value,
                DisplayName: getI18nKeyForMetadataDisplayName(group, key, kind) || transformedMetadata[key].DisplayName,
            };
        }
    });

    return transformedMetadata;
}
